import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import { FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { fetchResident, fetchBank } from "./Api/Api";
import { InsertUpdate } from "./Api/Api";
import moment from "moment/moment";
import PersonIcon from '@mui/icons-material/Person';
import InputAdornment from '@mui/material/InputAdornment';
import { Payment as PaymentIcon, AccountBalance as AccountBalanceIcon, CreditCard as CreditCardIcon, PaymentTwoTone as PaymentTwoToneIcon, Public as PublicIcon } from '@mui/icons-material';
import PaymentsIcon from '@mui/icons-material/Payments';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import CustomAutocomplete from "../../AutoComplete/AutoComplete";
import axiosInstance from "../../../lib/axios";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB } from 'date-fns/locale';
import { format, isValid } from 'date-fns';
import { selectGlobalProperty } from "../../../redux/propertySlice";
import { useSelector } from "react-redux";

const ReceiptStepper1 = ({ onResidentsLoad, AllTextDisabled, AllButtonDisabled,
  setAllButtonDisabled, formData, setFormData, handleCancel, fetchReceiptData, RecId,
  handleStepClick, setRecId, disableResidentFields, setDisableResidentFields, tableData, calculateTotalAmount
}) => {
  const [selectedImage, setSelectedImage] = useState("");
  const [residents, setResidents] = useState([]);
  const [bankData, setBankData] = useState([]);
  const navigate = useNavigate();
  const currentDate = new Date().toISOString().split("T")[0];
  const [chequeDialogOpen, setChequeDialogOpen] = useState(false);
  const [duplicateReceiptData, setDuplicateReceiptData] = useState(null);
  const [Propertydrp, setPropertydrp] = useState([]);
  const UserId = sessionStorage.getItem('UserId');
  const [isRcdAmtFromStepper2, setIsRcdAmtFromStepper2] = useState(false);
  const location = useLocation();
  const globalProperty = useSelector(selectGlobalProperty);
  const { selectedRows } = location?.state || {};
  let selectedRowsData = selectedRows;
  if (!selectedRowsData) {
    const storedData = sessionStorage.getItem('receiptData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      selectedRowsData = parsedData.selectedRows;
      sessionStorage.removeItem('receiptData');
    }
  }


  useEffect(() => {
    const totalAmountFromStepper2 = calculateTotalAmount();
    const hasTableData = tableData && tableData.length > 0;
    const hasTrnRctVchrList = formData?.TrnRctVchrList && formData.TrnRctVchrList.length > 0;

    if ((hasTableData || hasTrnRctVchrList) &&
      (formData.RcdAmt === 0 || formData.RcdAmt === "" ||
        parseFloat(formData.RcdAmt) === parseFloat(totalAmountFromStepper2))) {
      setIsRcdAmtFromStepper2(true);
    } else {
      setIsRcdAmtFromStepper2(false);
    }
  }, [tableData, formData.TrnRctVchrList, formData.RcdAmt, calculateTotalAmount]);
  const residentId = selectedRowsData?.[0]?.ResidentId;
  const propertyId = selectedRowsData?.[0]?.PropId;

  const checkDuplicateChequeNo = async (chequeNo) => {
    if (!chequeNo || !formData.PropId || formData.Pyttype === "Cash") return;

    try {
      const payload = {
        PageNumber: 1,
        PageSize: 1,
        SearchText: chequeNo,
        PropId: formData.PropId,
        SearchFrom: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        SearchTo: moment().format('YYYY-MM-DD'),
        Flag: "TrnIdChk"
      };

      const response = await axiosInstance.post(
        "TrnRctVchr/GetTrnRctVchrFilterDashBoard",
        payload
      );

      if (response.data.Status === 0 &&
        response.data.Data &&
        response.data.Data.length > 0 &&
        response.data.Data[0].RecId !== RecId) {

        setDuplicateReceiptData(response.data.Data[0]);
        setChequeDialogOpen(true);
      }
    } catch (error) {
      console.error("Error checking duplicate cheque no:", error);
    }
  };

  useEffect(() => {
    if (formData.ChequeNo && formData.Pyttype !== "Cash") {
      const timer = setTimeout(() => {
        checkDuplicateChequeNo(formData.ChequeNo);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [formData.ChequeNo, formData.PropId, formData.Pyttype]);

  const handleChequeNoChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  useEffect(() => {
    const fetchPropertyData = async () => {
      try {
        const response = await axiosInstance.post(`PropertyMst/GetPropertyMstUserwisedrp`, {
          UserId,
          Flag: ""
        });
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setPropertydrp(response.data.Data);
          if (propertyId) {
            setFormData((prevState) => ({
              ...prevState,
              PropId: propertyId,
            }));
          } else if (response.data.Data.length > 0 && !formData.PropId) {
            setFormData((prevState) => ({
              ...prevState,
              PropId: response.data.Data[0].Id,
            }));
          }
        } else {
          toast.error('Failed to fetch Property');
        }
      } catch (error) {
        console.error('Error fetching Property', error);
        toast.error('Error fetching Property. Please try again.');
      }
    };
    fetchPropertyData();
  }, [formData.PropId, setFormData]);


  useEffect(() => {
    const loadResidents = async () => {
      try {
        const response = await fetchResident({
          start: 1,
          PageSize: 1,
          SearchText: "drp",
        });
        if (response && response.data && Array.isArray(response.data.Data)) {
          setResidents(response.data.Data);
          onResidentsLoad(response.data.Data);
          if (residentId) {
            const foundResident = response.data.Data.find(res => res.ResidentId === residentId);
            if (foundResident) {
              setFormData(prev => ({
                ...prev,
                ResidentId: foundResident.ResidentId
              }));
            }
          }
        } else {
          toast.error("No residents data found or invalid response format");
        }
      } catch (error) {
        console.error("Error fetching residents:", error);
        toast.error("Failed to load residents data");
      }
    };
    loadResidents();
  }, [residentId]);

  useEffect(() => {
    const loadBank = async () => {
      try {
        const response = await fetchBank();
        if (response && response.data && Array.isArray(response.data.Data)) {
          setBankData(response.data.Data);
        } else {
          toast.error("No bank data found or invalid response format");
        }
      } catch (error) {
        toast.error("Failed to load bank data");
      }
    };
    loadBank();
  }, []);


  useEffect(() => {
    if (!formData.Pyttype) {
      setFormData((prevState) => ({
        ...prevState,
        Pyttype: "Cash",
      }));
    }
  }, [formData, setFormData]);

  useEffect(() => {
    if (formData.Pyttype === "Cash" && bankData.length > 0) {
      setFormData((prevState) => ({
        ...prevState,
        AccLedId: 1,
      }));
    }
  }, [formData.Pyttype, bankData]);

  // Handle input field changes
  const handleFieldChange = (field) => (event) => {
    const { value } = event.target;
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "RcdAmt" && isRcdAmtFromStepper2) {
      setIsRcdAmtFromStepper2(false);
    }

    setFormData(prevData => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };

      if (name === "RcdAmt" || name === "AgstBill") {
        const rcdAmt = parseFloat(name === "RcdAmt" ? value : updatedData.RcdAmt) || 0;
        const agstBill = parseFloat(name === "AgstBill" ? value : updatedData.AgstBill) || 0;
        const onacAmt = rcdAmt - agstBill;

        updatedData.OnacAmt = isNaN(onacAmt) ? '' : onacAmt.toFixed(2);
      }

      return updatedData;
    });
  };

  const shouldDisableRcdAmt = () => {
    return AllTextDisabled || isRcdAmtFromStepper2;
  };

  const getRcdAmtValue = () => {
    if (isRcdAmtFromStepper2) {
      return calculateTotalAmount() || formData.RcdAmt || "";
    } else {
      return formData.RcdAmt !== undefined && formData.RcdAmt !== null ? formData.RcdAmt : "";
    }
  };


  const handleRadioChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      readFileAsBase64(file)
        .then((base64String) => {
          setSelectedImage(base64String);
        })
        .catch((err) => {
          console.error("Error reading file:", err);
          toast.error("Error reading file. Please try again.");
        });
    }
  };


  const handleNextButtonClick = () => {
    const missingFields = [];
    if (formData.Pyttype === "Bank" || formData.Pyttype === "Card" || formData.Pyttype === "RTGS/NEFT") {
      if (!formData.BankName) missingFields.push("Customer Bank");
      if (!formData.ChequeNo) missingFields.push("Cheque No/Transaction Id");
      if (!formData.AccLedId) missingFields.push("Our Bank/Ledger");
    }
    if (!formData.ResidentId) missingFields.push("Resident/Corporate");
    if (missingFields.length > 0) {
      const missingFieldsMessage = missingFields.join(", ");
      toast.error(`Please fill the mandatory fields: ${missingFieldsMessage}.`);
      return;
    }
    handleStepClick(1);
  };

  useEffect(() => {
    if (formData.RcdAmt && formData.AgstBill) {
      const onacAmt = parseFloat(formData.RcdAmt) - parseFloat(formData.AgstBill);
      setFormData(prevData => ({
        ...prevData,
        OnacAmt: isNaN(onacAmt) ? '' : onacAmt.toFixed(2)
      }));
    }
  }, [formData.RcdAmt, formData.AgstBill]);


  useEffect(() => {
    const shouldFocus = localStorage.getItem('focusRcdAmt');
    if (shouldFocus === 'true') {
      localStorage.removeItem('focusRcdAmt');
      const rcdAmtField = document.querySelector('input[name="RcdAmt"]');
      if (rcdAmtField) {
        rcdAmtField.focus();
        rcdAmtField.select();
      }
    }
  }, []);

  const calculateTotalAmountInStepper1 = () => {
    const uniqueRows = [];
    const processedPytAdvNos = new Set();

    if (formData?.TrnRctVchrList && formData.TrnRctVchrList.length > 0) {
      formData.TrnRctVchrList.forEach(row => {
        if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== 'D') {
          uniqueRows.push(row);
          processedPytAdvNos.add(row.PytAdvNo);
        }
      });
    }

    if (tableData && tableData.length > 0) {
      tableData.forEach(row => {
        if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== 'D') {
          uniqueRows.push(row);
          processedPytAdvNos.add(row.PytAdvNo);
        }
      });
    }

    const totalAmount = uniqueRows.reduce((total, row) => {
      return total + parseFloat(row.Amount || 0);
    }, 0).toFixed(2);

    return totalAmount;
  };

  const DuplicateChequeDialog = () => (
    <Dialog open={chequeDialogOpen} onClose={() => setChequeDialogOpen(false)}>
      <DialogTitle
        sx={{
          color: 'white',
          bgcolor: 'warning.light',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        Duplicate Transaction ID Found!
        <Button
          onClick={() => setChequeDialogOpen(false)}
          sx={{
            minWidth: 'auto',
            color: 'white',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.1)'
            }
          }}
        >
          ✕
        </Button>
      </DialogTitle>
      <DialogContent>
        {duplicateReceiptData && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" gutterBottom>
              This Transaction ID has already been used in another receipt.
            </Typography>
            <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>
                Existing Receipt Details:
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography variant="body2">
                    <strong>Receipt No:</strong> {duplicateReceiptData.RecNo}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2">
                    <strong>Date:</strong> {moment(duplicateReceiptData.RecDt).format('DD/MM/YYYY')}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2">
                    <strong>Amount:</strong> ₹{duplicateReceiptData.RcdAmt}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2">
                    <strong>Resident:</strong> {duplicateReceiptData.ResidentName}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2">
                    <strong>Property:</strong> {duplicateReceiptData.PropName}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Typography variant="body2" sx={{ mt: 2, color: 'warning.dark' }}>
              Please verify the Transaction ID or use a different one.
            </Typography>
          </Box>
        )}
      </DialogContent>

    </Dialog>
  );

  return (
    <Grid container spacing={1}>
      <Grid container spacing={1}>
        <Grid item lg={8} md={8} xs={12}>
          <Box display="flex" flexDirection="column" gap={0.5}>
            <Grid container spacing={0.5}>
              <Grid item xs={12} md={6}>
                <CustomAutocomplete
                  options={Propertydrp}
                  id="PropId-autocomplete"
                  name="PropId"
                  label={
                    <span>
                      Property<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  getOptionLabel={(option) => option.Name || ""}
                  value={Propertydrp.find((prop) => prop.Id === formData.PropId) || null}
                  onChange={handleChange}
                  disabled={AllTextDisabled || disableResidentFields || (formData.AgstBill > 0)}
                  isOptionEqualToValue={(option, value) => option.Id === value.Id}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  value={formData.RecNo || ""}
                  label="Voucher No"
                  name=""
                  variant="filled"
                  className="custom-textfield"
                  disabled
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={enGB}>
                  <DatePicker
                    label="Voucher Date"
                    value={formData.RecDt ? new Date(formData.RecDt) : new Date()}
                    onChange={(newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        // RecDt: newValue ? format(newValue, 'yyyy-MM-dd') : '',
                        RecDt: newValue && isValid(newValue) ? format(newValue, 'yyyy-MM-dd') : '',
                      }));
                    }}
                    disabled={AllTextDisabled}
                    views={['day', 'month', 'year']}
                    openTo="day"
                    format="dd/MM/yyyy"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        variant: "filled",
                        className: "custom-textfield",
                        InputLabelProps: { shrink: true },
                        inputProps: { max: currentDate },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>

            <Grid container spacing={0.5}>
              <Grid item xs={12} md={6}>
                <FormControl variant="filled" fullWidth className="custom-select">
                  <Autocomplete
                    id="ResidentId"
                    name="ResidentId"
                    value={residents.find((resident) => resident.ResidentId === formData.ResidentId) || null}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        handleFieldChange("ResidentId")({ target: { value: newValue.ResidentId } });
                      } else {
                        handleFieldChange("ResidentId")({ target: { value: "" } });
                      }
                    }}
                    options={residents}
                    getOptionLabel={(option) => `${option.Name}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<>Resident/Corporate <span style={{ color: "red" }}>*</span></>}
                        variant="filled"
                        fullWidth
                      />
                    )}
                    disabled={AllTextDisabled || disableResidentFields || (formData.AgstBill > 0)}
                    className="custom-textfield"
                    isOptionEqualToValue={(option, value) => option.ResidentId === value.ResidentId}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControl variant="filled" fullWidth className="custom-select">
                  <Autocomplete
                    id="ResidentId"
                    name="ResidentId"
                    value={residents.find((resident) => resident.ResidentId === formData.ResidentId) || null}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        handleFieldChange("ResidentId")({ target: { value: newValue.ResidentId } });
                      }
                    }}
                    options={residents}
                    getOptionLabel={(option) => `${option.Mobile}`}
                    renderInput={(params) => (
                      <TextField {...params} label="Resident Mobile" variant="filled" fullWidth />
                    )}
                    disabled={AllTextDisabled || disableResidentFields || (formData.AgstBill > 0)}
                    className="custom-textfield"
                    isOptionEqualToValue={(option, value) => option.ResidentId === value.ResidentId}
                    disableClearable
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Ref_No"
                  name="RctVchrRef"
                  variant="filled"
                  className="custom-textfield"
                  disabled={AllTextDisabled}
                  value={formData.RctVchrRef || ""}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>

            <Grid item lg={12} md={12} xs={12}>
              <Box display="flex" flexDirection="column" gap={1}>
                <Grid container spacing={0.5}>
                  <Grid item xs={12} md={12}>
                    <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: "9px" }}>
                      <Grid item>
                        <FormLabel component="legend">Payment Method</FormLabel>
                      </Grid>
                      <Grid item>
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="Pyttype"
                            name="Pyttype"
                            onChange={(e) => handleRadioChange("Pyttype", e.target.value)}
                            value={formData.Pyttype || "Cash"}
                            row
                          >
                            <FormControlLabel
                              value="Cash"
                              control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                              label={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <PaymentsIcon sx={{ fontSize: 18, marginRight: 0.2, marginLeft: 0, opacity: 0.7, color: "rgba(0, 0, 0, 0.5)" }} />
                                  Cash
                                </div>
                              }
                              className="custom-textfield"
                              disabled={AllTextDisabled}
                            />
                            <FormControlLabel
                              value="Bank"
                              control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                              label={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <AccountBalanceIcon sx={{ fontSize: 18, marginRight: 0.2, marginLeft: 0, opacity: 0.7, color: "rgba(0, 0, 0, 0.5)" }} />
                                  Bank
                                </div>
                              }
                              className="custom-textfield"
                              disabled={AllTextDisabled}
                            />
                            <FormControlLabel
                              value="Card"
                              control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                              label={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <CreditCardIcon sx={{ fontSize: 18, marginRight: 0.2, marginLeft: 0, opacity: 0.7, color: "rgba(0, 0, 0, 0.5)" }} />
                                  Card
                                </div>
                              }
                              className="custom-textfield"
                              disabled={AllTextDisabled}
                            />
                            <FormControlLabel
                              value="RTGS/NEFT"
                              control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                              label={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <PublishedWithChangesIcon sx={{ fontSize: 18, marginRight: 0.2, marginLeft: 0, opacity: 0.7, color: "rgba(0, 0, 0, 0.5)" }} />
                                  RTGS/NEFT
                                </div>
                              }
                              className="custom-textfield"
                              disabled={AllTextDisabled}
                            />
                            <FormControlLabel
                              value="Online"
                              control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                              label={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <PublicIcon sx={{ fontSize: 18, marginRight: 0.2, marginLeft: 0, opacity: 0.7, color: "rgba(0, 0, 0, 0.5)" }} />
                                  Online
                                </div>
                              }
                              className="custom-textfield"
                              disabled={AllTextDisabled}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  {formData.Pyttype !== "Cash" && (
                    <>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label={<span>Customer Bank<span style={{ color: "red" }}>*</span></span>}
                          name="BankName"
                          variant="filled"
                          className="custom-textfield"
                          disabled={AllTextDisabled}
                          value={formData.BankName || ""}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Card No"
                          name="CardNo"
                          variant="filled"
                          className="custom-textfield"
                          disabled={AllTextDisabled}
                          value={formData.CardNo || ""}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label={<span>Cheque No/Transaction Id<span style={{ color: "red" }}>*</span></span>}
                          name="ChequeNo"
                          variant="filled"
                          className="custom-textfield"
                          disabled={AllTextDisabled}
                          value={formData.ChequeNo || ""}
                          onChange={handleChequeNoChange}
                        />
                      </Grid>

                      {/* <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label={<span>Cheque Date/Transaction Date<span style={{ color: "red" }}>*</span></span>}
                          name="ChqDt"
                          variant="filled"
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          className="custom-textfield"
                          disabled={AllTextDisabled}
                          value={formData.ChqDt ? moment(formData.ChqDt).format("YYYY-MM-DD") : currentDate}
                          onChange={handleChange}
                        />
                      </Grid> */}


                    </>
                  )}
                  <Grid item xs={12} md={6} lg={6}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={enGB}>
                      <DatePicker
                        label={<span>Cheque Date/Transaction Date<span style={{ color: "red" }}>*</span></span>}
                        // value={formData.ChqDt ? new Date(formData.ChqDt) : new Date()}
                        value={formData.ChqDt ? new Date(formData.ChqDt) : (formData.RecDt ? new Date(formData.RecDt) : new Date())}
                        onChange={(newValue) => {
                          setFormData((prev) => ({
                            ...prev,
                            // ChqDt: newValue ? format(newValue, 'yyyy-MM-dd') : '',
                            ChqDt: newValue && isValid(newValue) ? format(newValue, 'yyyy-MM-dd') : '',
                          }));
                        }}
                        disabled={AllTextDisabled}
                        views={['day', 'month', 'year']}
                        openTo="day"
                        format="dd/MM/yyyy"
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            variant: "filled",
                            className: "custom-textfield",
                            InputLabelProps: { shrink: true },
                            inputProps: { max: currentDate },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <FormControl variant="filled" fullWidth className="custom-select">
                      <InputLabel id="AccLedId-select-label">Our Bank/Ledger <span style={{ color: "red" }}>*</span></InputLabel>
                      <Select
                        labelId="AccLedId-select-label"
                        id="AccLedId"
                        name="AccLedId"
                        value={formData.AccLedId || ""}
                        onChange={handleFieldChange("AccLedId")}
                        className="custom-textfield"
                        disabled={AllTextDisabled}
                      >
                        {formData.Pyttype === "Cash"
                          ? bankData
                            .filter((bank) => bank.Id === 1)
                            .map((bank) => (
                              <MenuItem key={bank.Id} value={bank.Id}>
                                {bank.Name}
                              </MenuItem>
                            ))
                          : bankData
                            .filter((bank) => bank.Id !== 1)
                            .map((bank) => (
                              <MenuItem key={bank.Id} value={bank.Id}>
                                {bank.Name}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: "9px" }}>
                      <Grid item>
                        <FormLabel component="legend">Receive Type</FormLabel>
                      </Grid>
                      <Grid item>
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="RecFlag"
                            name="RecFlag"
                            onChange={(e) => handleRadioChange("RecFlag", e.target.value)}
                            value={formData.RecFlag || "R"}
                            row
                          >
                            <FormControlLabel
                              value="D"
                              control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                              label="Deposit"
                              className="custom-textfield"
                              disabled={AllTextDisabled}
                            />
                            <FormControlLabel
                              value="R"
                              control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                              label="Rent/Others"
                              className="custom-textfield"
                              disabled={AllTextDisabled}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label={<span>Received Amount <span style={{ color: "red" }}>*</span></span>}
                      name="RcdAmt"
                      variant="filled"
                      className="custom-textfield"
                      disabled={shouldDisableRcdAmt()}
                      // value={formData.RcdAmt !== undefined && formData.RcdAmt !== null ? formData.RcdAmt : ""}
                      value={getRcdAmtValue()}
                      onChange={handleChange}
                      slotProps={{
                        htmlInput: {
                          title: isRcdAmtFromStepper2 ?
                            "Amount is automatically calculated from Stepper 2. Go to Stepper 2 to modify allocations." :
                            ""
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Against Bill Amount"
                      name="AgstBill"
                      variant="filled"
                      className="custom-textfield"
                      disabled
                      value={formData.AgstBill !== undefined && formData.AgstBill !== null ? formData.AgstBill : ""}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="On Account"
                      name="OnacAmt"
                      variant="filled"
                      className="custom-textfield"
                      disabled
                      value={formData.OnacAmt !== undefined && formData.OnacAmt !== null ? formData.OnacAmt : ""}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="On Account Balance"
                      name="OnacBal"
                      variant="filled"
                      className="custom-textfield"
                      disabled
                      value={formData.OnacBal !== undefined && formData.OnacBal !== null ? formData.OnacBal : ""}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      fullWidth
                      label="Remark"
                      name="Remark"
                      variant="filled"
                      className="custom-textfield"
                      disabled={AllTextDisabled}
                      value={formData.Remark || ""}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Grid>

        <Grid item lg={2} md={2} xs={12} display="flex" sx={{ marginTop: "10px", marginLeft: "50px", flexDirection: 'column', alignItems: 'center' }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            border="1px solid #ccc"
            borderRadius={1}
            width={150}
            height={145}
            overflow="hidden"
            position="relative"
            sx={{ cursor: "pointer", border: 1, borderColor: "black" }}
          >
            {selectedImage ? (
              <img
                src={selectedImage}
                alt="Uploaded Logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <Typography variant="body2" color="textSecondary">
                Browse
              </Typography>
            )}

            <input
              id="upload-photo"
              type="file"
              accept="image/*"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
              }}
              onChange={handleFileChange}
              disabled={AllTextDisabled}
            />
          </Box>
          <label htmlFor="upload-photo">
            <Button component="span" style={{ marginTop: "10px" }}>
              Upload Image
            </Button>
          </label>
        </Grid>
      </Grid>

      <Grid item xs={12} className="form_button" gap="10px">
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: AllTextDisabled
              ? "linear-gradient(290deg, #e0e0e0, #b0b0b0)"
              : " backgroundColor: #635bff",
            color: AllTextDisabled ? '#9e9e9e !important' : '#fff !important',
            '&:disabled': {
              background: "linear-gradient(290deg, #e0e0e0, #b0b0b0)",
              color: '#9e9e9e !important'
            }
          }}
          disabled={AllTextDisabled}
          onClick={handleNextButtonClick}
        >
          Next
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: AllTextDisabled
              ? "linear-gradient(290deg, #e0e0e0, #b0b0b0)"
              : "linear-gradient(290deg, #4a6572, #6c8a9d)",
            color: AllTextDisabled ? '#9e9e9e !important' : '#fff !important',
            '&:disabled': {
              background: "linear-gradient(290deg, #e0e0e0, #b0b0b0)",
              color: '#9e9e9e !important'
            }
          }}
          disabled={AllTextDisabled}
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </Grid>
      <DuplicateChequeDialog />
    </Grid>
  );
};

export default ReceiptStepper1;